/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dot-separator': {
    width: 3,
    height: 3,
    viewBox: '0 0 3 3',
    data: '<circle pid="0" cx="1.5" cy="1.5" r="1.5" _fill="#7888A1"/>'
  }
})
